import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "../../store";
import { Box, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { confirmSignIn, fetchAuthSession, signIn } from "aws-amplify/auth";
import { fetchAwsUser } from "../../slices/auth";
import LoginHeader from "../base/LoginHeader";

interface Props {}

const InviteView: React.FC<Props> = (props) => {
  const [searchParams] = useSearchParams();

  const [status, setStatus] = useState<
    "done" | "confirming" | "verifying" | "redirecting" | "error"
  >("done");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const email = searchParams.get("email");
    const token = searchParams.get("token");

    if (!email || !token) {
      navigate("/auth/login", { replace: true });
      return;
    }

    const run = async () => {
      try {
        setStatus("confirming");

        const out = await signIn({
          username: email,
          options: { authFlowType: "CUSTOM_WITHOUT_SRP" },
        });

        setStatus("verifying");

        if (
          out.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE"
        ) {
          const out2 = await confirmSignIn({ challengeResponse: token });

          if (out2.nextStep.signInStep !== "DONE") {
            throw new Error(
              `Unexpected nextStep after confirm: ${out2.nextStep.signInStep}`
            );
          }
        } else if (out.nextStep.signInStep !== "DONE") {
          throw new Error(
            `Unexpected nextStep after signIn: ${out.nextStep.signInStep}`
          );
        }

        setStatus("redirecting");

        await fetchAuthSession();
        await dispatch(fetchAwsUser());
        navigate("/", { replace: true });
      } catch (error) {
        console.error("Invite flow failed:", error);
        setStatus("error");
      }
    };

    void run();
  }, [searchParams, dispatch, navigate]);

  return (
    <Box display="flex" justifyContent="center">
      <Box
        justifySelf="center"
        boxSizing="border-box"
        display="block"
        maxWidth={"100%"}
      >
        <LoginHeader />
        <Box display="flex" flexDirection={"row"} justifyContent={"center"}>
          <Typography variant="overline" fontSize={"15px"}>
            {status}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default InviteView;
